<template>
  <div class="container page">
    <van-nav-bar :title="videoInfo.vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back" />
      </template>
    </van-nav-bar>

    <div class="movie-video">
      <video
        ref="videoPlayer"
        class="video-player"
        :class="{ 'video-locked': vipDialogShown }"
        :controls="!showVipPopup"
        playsinline
        webkit-playsinline
        preload="auto"
        :poster="cover"
      ></video>
      <div class="video-lock-mask" v-if="vipDialogShown" @click="showVipPopup = true">
        <div>试看已结束</div>
        <button>购买VIP继续观看</button>
      </div>
      <div class="video-permission-mask" v-if="!hasVideoPermission">
        <div>请联系客服获取观看视频权限</div>
        <button @click="toService">联系客服</button>
      </div>
    </div>

    <div class="movie-content">
      <div class="movie-descript">
        <p>{{ videoInfo.vod_name }}</p>
        <span>{{ videoInfo.count }}{{ $t("video.num_play") }}</span>
      </div>

      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>猜你喜欢</span>
          </div>
        </div>

        <div class="movie_list_1">
          <div
            class="movie-list-item"
            v-for="(item, key) in moreVideoInfo"
            :key="key"
            @click="toPlayVideo(item.id)"
          >
            <van-image class="cover_img" round :src="item.cover">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
            <div class="movie-list-item-bottom">
              <div class="movie-time-div">
                <span>{{ item.vod_name }}</span>
                <span>{{ $t('video.play') }}:{{ item.count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showVipPopup" class="vip-popup" round>
      <div class="vip-modal">
        <div class="vip-title">试看结束</div>
        <div class="vip-message">是否购买VIP继续观看？</div>
        <div class="vip-price">VIP价格：{{ videoInfo.vip_money || 0 }}</div>
        <div class="vip-actions">
          <button class="vip-cancel" @click="showVipPopup = false">取消</button>
          <button class="vip-confirm" @click="buyVideoVip">{{ buyingVip ? '购买中...' : '去购买' }}</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nowPlayVideoUrl: '',
      cover: '',
      userInfo: {},
      videoInfo: {},
      moreVideoInfo: [],
      hlsPlayer: null,
      times: null,
      isPlaying: false,
      trialLimitSeconds: 0,
      vipDialogShown: false,
      showVipPopup: false,
      buyingVip: false,
      hasVideoPermission: true
    };
  },
  computed: {
    isFreeVideo() {
      return Number(this.videoInfo.vod_free) === 1;
    }
  },
  methods: {
    back() {
      this.$router.push({ path: '/Video' });
    },
    getVideoInfo() {
      this.$http({
        method: 'get',
        data: { id: this.$route.query.id },
        url: 'video_get_info'
      }).then(res => {
        if (res.code === 401) {
          this.$toast('请联系客服获取观看视频权限');
          this.videoInfo = {};
          this.nowPlayVideoUrl = '';
          this.cover = '';
          this.hasVideoPermission = false;
          this.destroyPlayer();
          return;
        }
        this.videoInfo = res.data || {};
        if (!this.isFreeVideo && Number(this.videoInfo.is_video) === 0) {
          this.hasVideoPermission = false;
          this.nowPlayVideoUrl = '';
          this.cover = this.videoInfo.vod_pic || '';
          this.destroyPlayer();
          return;
        }
        this.hasVideoPermission = true;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url || '';
        this.cover = this.videoInfo.vod_pic || '';
        this.trialLimitSeconds = this.isFreeVideo ? 0 : Number(this.videoInfo.video_s || 0);
        this.vipDialogShown = false;
        this.showVipPopup = false;
        console.log('video info', this.videoInfo);
        this.initVideo();
      });
    },
    getMoreVideoItem() {
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res => {
        this.moreVideoInfo = res.data || [];
      });
    },
    toService() {
      const service = this.$store.getters.getBaseInfo;
      if (service && service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        const config = res.data || {};
        if (config.iskefu == 1 && config.kefu) {
          window.location.href = config.kefu;
        } else {
          this.$toast('客服暂未开启');
        }
      }).catch(() => {
        this.$toast('客服暂未开启');
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
            return;
          }
        }
        this.getVideoInfo();
        this.getMoreVideoItem();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
        return;
      }
      this.$router.push({ path: '/PlayVideo', query: { id } });
      this.$nextTick(() => {
        this.destroyPlayer();
        this.getVideoInfo();
      });
    },
    loadHlsScript() {
      if (window.Hls) {
        return Promise.resolve(window.Hls);
      }
      return new Promise((resolve, reject) => {
        const oldScript = document.getElementById('hlsjs-script');
        if (oldScript) {
          oldScript.onload = () => resolve(window.Hls);
          oldScript.onerror = reject;
          return;
        }
        const script = document.createElement('script');
        script.id = 'hlsjs-script';
        script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';
        script.onload = () => resolve(window.Hls);
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },
    initVideo() {
      const video = this.$refs.videoPlayer;
      if (!video || !this.nowPlayVideoUrl) {
        return;
      }
      this.destroyPlayer();
      video.poster = this.cover;
      video.onplay = () => {
        if (this.vipDialogShown || this.showVipPopup) {
          video.pause();
          return;
        }
        this.isPlaying = true;
      };
      video.onerror = () => {
        console.log('play video error', video.error);
      };

      if (this.nowPlayVideoUrl.indexOf('.m3u8') === -1) {
        video.src = this.nowPlayVideoUrl;
        video.load();
        return;
      }

      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.nowPlayVideoUrl;
        video.load();
        return;
      }

      this.loadHlsScript().then(Hls => {
        if (!Hls || !Hls.isSupported()) {
          this.$toast('当前浏览器不支持该视频格式');
          return;
        }
        this.hlsPlayer = new Hls();
        this.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
          console.log('hls video error', event, data);
        });
        this.hlsPlayer.loadSource(this.nowPlayVideoUrl);
        this.hlsPlayer.attachMedia(video);
      }).catch(err => {
        console.log('hls script load error', err);
        this.$toast('视频播放器加载失败');
      });
    },
    destroyPlayer() {
      if (this.hlsPlayer) {
        this.hlsPlayer.destroy();
        this.hlsPlayer = null;
      }
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
    },
    showVipDialog() {
      if (this.vipDialogShown) {
        return;
      }
      this.vipDialogShown = true;
      this.showVipPopup = true;
      this.destroyPlayer();
    },
    buyVideoVip() {
      if (this.buyingVip) {
        return;
      }
      this.buyingVip = true;
      this.$http({
        method: 'post',
        url: 'buy_video_vip',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.buyingVip = false;
        if (res.code === 200) {
          this.$toast(res.msg || '购买成功');
          this.showVipPopup = false;
          this.vipDialogShown = false;
          this.getUserInfo();
          return;
        }
        this.$toast(res.msg || '购买失败');
      }).catch(() => {
        this.buyingVip = false;
        this.$toast('购买失败');
      });
    }
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.getUserInfo();
    this.times = setInterval(() => {
      const video = this.$refs.videoPlayer;
      if (this.isPlaying && !this.isFreeVideo && this.trialLimitSeconds > 0 && video) {
        const ct = Math.round(video.currentTime || 0);
        if (this.vipDialogShown && ct >= this.trialLimitSeconds) {
          video.pause();
          return;
        }
        if (ct >= this.trialLimitSeconds) {
          video.pause();
          this.showVipDialog();
        }
      }
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.times);
    this.destroyPlayer();
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #29243d;
}

.nav-bar {
  background: linear-gradient(270deg, #323795, #4c206f);
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  color: #fff;
  font-size: 32px;
}

.movie-video {
  position: relative;
  width: 100%;
  background: #000;
}

.video-player {
  display: block;
  width: 100%;
  height: 420px;
  background: #000;
  object-fit: contain;
}

.video-locked {
  pointer-events: none;
}

.video-lock-mask,
.video-permission-mask {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(0, 0, 0, .72);
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

.video-lock-mask button,
.video-permission-mask button {
  height: 68px;
  padding: 0 34px;
  border: none;
  border-radius: 999px;
  background: #ff4ea3;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

.video-permission-mask {
  z-index: 6;
  text-align: center;
}

.movie-content {
  overflow-y: auto;
}

.movie-descript {
  padding: 15px;
  color: #fff;
}

.movie-descript p {
  margin: 0 0 8px;
  font-size: 30px;
  font-weight: 700;
}

.movie-descript span {
  color: #cfc8dd;
}

.movie-body {
  width: calc(100% - 20px);
  margin: 0 auto;
}

.movie-title {
  height: 70px;
  display: flex;
  align-items: center;
}

.movie-title span {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: 700;
  color: #fff;
}

.movie-title span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  margin-right: 10px;
  border-radius: 25px;
  background-color: #f487e0;
}

.movie_list_1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.movie-list-item {
  width: calc(50% - 8px);
  margin-bottom: 12px;
}

.cover_img {
  width: 100%;
  height: 250px;
  border-radius: 10px;
}

.movie-list-item-bottom {
  position: relative;
  bottom: 42px;
}

.movie-time-div {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  border-radius: 0 0 10px 10px;
  background-color: rgba(0, 0, 0, .4);
  color: #fff;
}

.movie-time-div span {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 22px;
}

.vip-popup {
  width: 82%;
  max-width: 620px;
  background: #fff;
}

.vip-modal {
  padding: 34px 28px 0;
  text-align: center;
  color: #1f1a30;
}

.vip-title {
  font-size: 34px;
  font-weight: 700;
}

.vip-message {
  margin-top: 22px;
  font-size: 28px;
  line-height: 1.4;
}

.vip-price {
  margin-top: 12px;
  color: #ff4ea3;
  font-size: 30px;
  font-weight: 700;
}

.vip-actions {
  display: flex;
  margin: 34px -28px 0;
  border-top: 1px solid #eee;
}

.vip-actions button {
  flex: 1;
  height: 92px;
  border: none;
  background: #fff;
  font-size: 30px;
}

.vip-cancel {
  color: #555;
  border-right: 1px solid #eee !important;
}

.vip-confirm {
  color: #ff2f7d;
  font-weight: 700;
}
</style>
